module.exports = __webpack_public_path__ + "static/img/Frame 214-4.7642c61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/Frame 214-4.svg
// module id = 9BTa
// module chunks = 0